import { ReactNode } from 'react';

import { Label } from '@/design_system/Label/Label';
import { RadioItemGroup } from '@/design_system/Radio/RadioItem/RadioItem';
import Stack from '@/design_system/Stack';

import './FilterRadioGroupWithLabel.css';

type RadioProps = {
  id: string;
  title: string;
  label: string;
  value: string | null;
  onChange: (e: any) => void;
  children: ReactNode;
};

export const FilterRadioGroupWithLabel = ({
  id,
  title,
  label,
  value,
  onChange,
  children,
}: RadioProps) => {
  return (
    <Stack style={{ paddingLeft: '1em', paddingBottom: '8px' }}>
      <Label label={label} className="filters-radio-group" />
      <RadioItemGroup
        name={title}
        onChange={(e) => onChange(e)}
        key={id}
        direction="column"
        value={value}
      >
        {children}
      </RadioItemGroup>
    </Stack>
  );
};
